import { inject, Service, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BaasBasiscontext } from '@lvflanders/bar';

import { BarMelding } from '../models/bar-melding';
import { BarCoreService } from './bar-core.service';

/** Angular service holding reactive state (signals) regarding the application.*/
@Service({ autoProvided: false })
export class BaasCoreStateService {
    readonly #state = inject(_BarCoreStateService);
    readonly basiscontext = this.#state.basiscontext.asReadonly();
    readonly meldingen = this.#state.meldingen.asReadonly();
}

/** 
   Internal service which holds state of the BAR Angular core module within the single page.
   With this in place we can access the state anywhere.
 */
// NOTE not a model because injectable provider and not a service because it only holds state
@Service({ autoProvided: false })
export class _BarCoreStateService {
    readonly #coreService = inject(BarCoreService);

    /** Meldingen set by the BarMeldingGuard */
    readonly meldingen = signal<BarMelding[]>(undefined);
    readonly basiscontext = signal<BaasBasiscontext | undefined>(undefined);

    constructor() {
        this.#coreService.basiscontextChanged.pipe(takeUntilDestroyed()).subscribe((basiscontext) => this.basiscontext.set(basiscontext));
    }
}
